import ct from "class-types.macro";
import React from "react";
import { User } from "~/common/Store/models/User";
import Pagination from "../../../Pagination";
import ProductReview from "../ProductReview";
import { MediaIdentifier, ProductReviewDetail } from "../../reviewModels";
import warehouseLocation from "~/common/Store/models/warehouseLocation";

interface Props {
  productReviewDetails: ProductReviewDetail[];
  user: User;
  handleSelectMediaElement: (newMedia: MediaIdentifier | undefined) => void;
  addUserUpvote: (reviewId: number, upvoted: boolean) => void;
  currentReviewUpvotes: Readonly<Record<number, boolean>>;
  usePagination: boolean;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

const TextReviewsSection = ({
  addUserUpvote,
  currentReviewUpvotes,
  handleSelectMediaElement,
  productReviewDetails,
  usePagination,
  user,
  currentPage,
  setCurrentPage,
}: Props) => {
  const pageSize = 40;
  const numberOfReviews = productReviewDetails.length;
  const showPagination = numberOfReviews > pageSize;

  return (
    <>
      {numberOfReviews > 0 ? (
        productReviewDetails
          .slice((currentPage - 1) * pageSize, currentPage * pageSize)
          .map((productReviewDetail, index) => (
            <ProductReview
              review={productReviewDetail}
              reviewLocation={warehouseLocation.LeolaCDC2}
              user={user}
              key={productReviewDetail.reviewId}
              productReviewIndex={index}
              handleSelectMediaElement={handleSelectMediaElement}
              addUserUpvote={addUserUpvote}
              userUpvoted={!!currentReviewUpvotes[productReviewDetail.reviewId]}
              userVoted={
                currentReviewUpvotes[productReviewDetail.reviewId] !== undefined
              }
              verifiedPurchase={productReviewDetail.isVerifiedPurchase}
            />
          ))
      ) : (
        <span>No reviews match the current filter criteria.</span>
      )}
      {usePagination && showPagination && (
        <div
          data-testid="product-review-pagination"
          id="paging"
          className={ct("clear-both", "p-6", "text-center")}
        >
          <Pagination
            onChange={(page) => setCurrentPage(page)}
            currentPage={currentPage}
            total={productReviewDetails.length}
            pageSize={pageSize}
          />
        </div>
      )}
    </>
  );
};

export default TextReviewsSection;
